export class Persona {
    constructor(
        public Id: number | null,
        public readonly Nombre: string | null,
        public readonly Apellido: string | null,
        public readonly NroDocumento: string | null,
        public TipoDocumentoNombre: string | null,
        public readonly TipoDocumentoId: number | null,
        public FechaNacimiento: Date | null,
        public readonly Cuit: number | null,
        public readonly MailContacto: string | null,
        public MovilContacto: string | null,
        public Activo: boolean | null,
        public FotoDniFrenteUrl: string | null,
        public FotoDniDorsoUrl: string | null,
        public FotoSelfieUrl: string | null
    ) { }
}

export class SavePersonaDto {
    constructor(
        public readonly Id: number,
        public readonly Nombre: string | null,
        public readonly Apellido: string | null,
        public readonly TipoDocumentoId: number | null,
        public readonly NroDocumento: string | null,
        public readonly Cuit: string | null,
        public readonly MailContacto: string | null,
        public readonly MovilContacto: string | null,
        public readonly FechaNacimiento: Date | null,
        public readonly Activo: boolean,
        public readonly FotoDniFrenteBase64: string | null,
        public readonly FotoDniFrenteExtension: string | null,
        public readonly FotoDniDorsoBase64: string | null,
        public readonly FotoDniDorsoExtension: string | null,
        public readonly FotoSelfieBase64: string | null,
        public readonly FotoSelfieExtension: string | null
    ) { }
}

export class SearchPersonaRequestDto {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Nombre: string | null,
        public readonly Apellido: string | null,
        public readonly TipoDocumentoId: number | null,
        public readonly NroDocumento: string | null,
        public readonly Cuit: number | null,
        public readonly MailContacto: string | null,
        public readonly MovilContacto: string | null,
        public readonly VerSoloActivos: boolean,
        public readonly VerSoloConUsuarios: boolean
    ) { }
}

export class SearchPersonaResponseDto {
    constructor(
        public readonly count: number,
        public readonly result: Persona[]
    ) { }
}

export class DialogPersonaSearchComponentRequestDto {
    constructor(
        public readonly AllowMultipleSelection: boolean,
        public readonly MaxItemSelection: number
    ) { }
}

export class DialogPersonaSearchComponentResponseDto {
    constructor(
        public readonly Cancelled: boolean,
        public readonly Items: Persona[]
    ) { }
}

export class SavePersonVerificationImageRequestDto {
    constructor(
        public readonly PersonaId: number,
        public readonly TipoFoto: string | null,
        public readonly FotoBase64: string | null,
        public readonly FotoExtension: string
    ) { }
}

export class DialogPersonaGestionRequestDto {
    constructor(
        public readonly Id: number,
    ) { }
}

export class DialogPersonaGestionResponseDto {
    constructor(
        public readonly Cancelled: boolean,
        public readonly Item: Persona | null
    ) { }
}
